<template>
  <div v-if="flag">
    <!-- 右侧下角小弹框 -->
    <div v-if="!isSellerwell()" class="entry-lite-mini" @click="updateLiteGuide(1)" :class="{ 'tooltipShow': tooltipShow }" >
      <span class="entry-lite-mini__text">
        {{ title }}
      </span>
      <div class="entry-lite-mini__star">
        <a-icon type="check-circle" theme="filled" :class="{ 'pass': guideInfo.guideSchedule[0] === '1' }" />
        <a-icon type="check-circle" theme="filled" :class="{ 'pass': guideInfo.guideSchedule[1] === '1' }" />
        <a-icon type="check-circle" theme="filled" :class="{ 'pass': guideInfo.guideSchedule[2] === '1' }" />
        <a-icon type="check-circle" theme="filled" :class="{ 'pass': guideInfo.guideSchedule[3] === '1' }" />
      </div>
      <icon-font type="gb-icon-a-xinshouyindao3" />
      <div class="entry-lite-mini__tooltip" @click.stop v-if="tooltipShow">
        <div v-for="item in progress.filter(find => localDefaultConfig.lite[find.prop] >= 100)" :key="item.title" @click="toSeek(item.path)">
          <a-icon type="check-circle" theme="filled" style="color: rgba(82, 196, 26, 1)" />
          <span>{{ item.success }}</span>
        </div>
        <i @click="hideToolTip"> <a-icon type="down" /></i>
      </div>
    </div>
    <!-- 中间弹窗 & 蒙板 -->
    <div class="entry-lite-tips">
      <div class="tip-mask"></div>
      <div class="tip-modal">
        <div class="tip-modal__title">
          <span>{{ title }}</span>
          <a-icon type="close" class="close-icon" @click="updateLiteGuide(4)" />
        </div>
        <div class="tip-modal__main-wrapper">
          <div class="tip-modal__main">
            <div class="tip-modal__main--lf">
              <b>欢迎您使用ECCANG ERP系统</b>
              <p>
                尊敬的易仓客户，欢迎您使用【ECCANG
                ERP系统】，我们是专注于亚马逊等平台的一站式精细化管理专家，我们是您的跨境业务首席增长官。
              </p>
              <!-- 视频 -->
              <div class="video-main" v-if="videos[0]">
                <video id="videoLiteBox" class="video-js" :src="videos[0].templateUrl" ></video>
              </div>
              <ul class="video-swiper">
                <li class="video-item-ob" v-for="video in videos" :key="video.templateUrl" :class="{'cur': video.templateUrl === curVideo.templateUrl }" @click="changeVideo(video)">
                  <div :style="{ backgroundImage: `url(${video.img})` }" ></div>
                  <i class="playing" v-if="video.templateUrl === curVideo.templateUrl">播放中</i>
                  <span>{{ video.businessCode }}</span>
                </li>
              </ul>
            </div>
            <div class="tip-modal__main--rt">
              <!-- 步骤 -->
              <template v-if="!guideInfo.guideSchedule.every(item => item === '1')">
                <!-- 第一步 -->
                <div class="step" :class="{ 'pass': guideInfo.guideSchedule[0] === '1' }">
                  <div class="step-top">
                    <b>第一步：店铺授权</b>
                    <p
                      v-if="guideInfo.guideSchedule[0] === '0'"
                      style="width: 346px"
                    >
                      授权成功后，系统会立刻对该店铺的数据进行自动获取和展示。若您有多个店铺，首次授权时，建议选择单量较少的店铺，可以很快看到数据哦
                    </p>
                    <p v-else style="width: 356px">
                      1. 授权成功后，系统会立刻对该店铺的数据进行自动获取和展示。<br>2. 若您有多个店铺，首次授权时，建议选择单量较少的店铺，可以很快看到数据哦
                    </p>
                    <div class="step-continue" v-if="guideInfo.guideSchedule[0] === '1'">
                      <p>
                        店铺授权已完成<br>
                        您可继续进行广告授权、邮箱授权
                      </p>
                      <div>
                        <!-- 广告授权 -->
                        <div class="inline-flex" style="margin-left: 10px" v-if="guideInfo.guideSchedule[2] === '1'">
                          <a-icon type="check-circle" theme="filled" />
                          <span>广告授权已完成</span>
                        </div>
                        <a-button v-else type="primary" size="small" @click="toAuth(2)">去广告授权</a-button>
                        <!-- 邮箱授权 -->
                        <div class="inline-flex" style="margin-left: 10px" v-if="guideInfo.guideSchedule[3] === '1'">
                          <a-icon type="check-circle" theme="filled" />
                          <span>邮箱授权已完成</span>
                        </div>
                        <a-button v-else type="primary" size="small" @click="toAuth(3)">去邮箱授权</a-button>
                      </div>
                    </div>
                    <div class="step-top__opt">
                      <template v-if="guideInfo.guideSchedule[0] === '0'">
                        <div v-if="userInfo.historicalStatus === 2">
                          <a-icon type="exclamation-circle" theme="filled" style="color: rgba(250, 173, 20, 1)" />未授权
                        </div>
                        <a-button type="primary" size="small" style="" @click="toAuth(1)" >去授权</a-button>
                      </template>
                      <template v-else>
                        <div>
                          <a-icon type="check-circle" theme="filled" style="color: rgba(82, 196, 26, 1)" />已授权: {{ guideInfo.platformUserName }}
                        </div>
                        <a-button type="primary" ghost size="small" @click="toAuth(1)">授权更多</a-button>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- 第二步 -->
                <div class="step" :class="{ 'pass': guideInfo.guideSchedule[1] === '1' }">
                  <div class="step-top">
                    <b>第二步：自动拉取数据</b>
                    <p style="width: 330px" >
                      1. 授权成功后，您即刻会在15-20分钟内看见以下数据。 <br />
                      2. Listing数据更新完后，只需维护成本一项，即刻获得多维度精细化利润报表，省去繁琐对账。<br />
                      3. 优先更新最近24小时的订单
                    </p>
                    <div
                      class="step-top__opt"
                      v-if="guideInfo.guideSchedule[1] === '0' && guideInfo.guideSchedule[0] === '1'"
                    >
                      <span class="opt-pull">拉取中…</span>
                      <div style="color: rgba(0, 0, 0, 0.65)">
                        预计15-20分钟完成
                      </div>
                    </div>
                  </div>
                  <!-- 进度 -->
                  <template>
                    <div class="progress-item" v-for="item in progress" :key="item.title" >
                      <div class="progress-item__pct">
                        <span v-if="guideInfo[item.prop] !== null">{{ guideInfo[item.prop] + "%" }}</span>
                      </div>
                      <div class="progress-item__pie">
                        <svg viewBox="0 0 42 42" class="circular-chart">
                          <path
                            class="circle-bg"
                            d="M21 6
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                          <path
                            class="circle"
                            v-if="guideInfo[item.prop] !== null"
                            :stroke-dasharray="`${guideInfo[item.prop]}, 100`"
                            d="M21 6
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                          />
                          <image
                            :xlink:href="item.img"
                            x="13"
                            y="13"
                            height="18"
                            width="18"
                          />
                        </svg>
                      </div>
                      <div class="progress-item__content">
                        <span>{{ item.title }}</span>
                        <p>{{ item.subtitle }}</p>
                      </div>
                      <div class="progress-item__pass" v-if="guideInfo[item.prop] >= 100 || userInfo.historicalStatus === 1">
                        <div v-if="guideInfo[item.prop] >= 100">
                          <a-icon type="check-circle" theme="filled" style="color: rgba(82, 196, 26, 1); margin-right: 5px" />已完成
                        </div>
                        <a-button type="link" @click="toSeek(item.path)">去查看</a-button>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
              <!-- 成功 -->
              <div class="step-success" v-else>
                <b>
                  恭喜您，已经完成{{ title }}，速度超过<span style="color: rgba(82, 196, 26, 1)">{{ Math.ceil(Math.random()*(94-80+1)+80) }}%</span>以上的用户
                </b>
                <div><img src="@/assets/img_noright.png" alt=""></div>
                <ul>
                  <li>
                    <a-icon type="check-circle" theme="filled"  style="color: rgba(82, 196, 26, 1)" />
                    店铺授权
                  </li>
                  <li>
                    <a-icon type="check-circle" theme="filled"  style="color: rgba(82, 196, 26, 1)" />
                    广告授权
                  </li>
                  <li>
                    <a-icon type="check-circle" theme="filled"  style="color: rgba(82, 196, 26, 1)" />
                    邮箱授权
                  </li>
                  <li>
                    <a-icon type="check-circle" theme="filled"  style="color: rgba(82, 196, 26, 1)" />
                    自动拉取数据
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="tip-modal__footer">
          <a-button v-if="$env !== 'production'" type="primary" ghost @click="test">走查用：模拟流程点这里（多次）{{guideInfo.guideSchedule}}</a-button>
          <a-button type="primary" v-if="guideInfo.guideSchedule[0] === '0' || guideInfo.guideSchedule.every(item => item === '1')" ghost @click="updateLiteGuide(3)">{{ guideInfo.guideSchedule.every(item => item === '1') ? '关闭引导' : '不再提示' }}</a-button>
          <a-button type="primary" v-if="!guideInfo.guideSchedule.every(item => item === '1')" @click="updateLiteGuide(4)">收起引导</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryLiteGuideInfo, updateLiteGuide } from '@/api/sso/subjectService'
import { QuerySystemParamsPage } from '@/api'
import { getVideoBase64 } from '@/utils/util'
import { IS_SELLERWELL } from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import cn from 'video.js/dist/lang/zh-CN.json'

export default {
  props: {
    guide: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flag: false, // 总开关
      visible: null, // 是否显示弹框
      timer: null,
      guideInfo: {
        guideSchedule: []
      },
      videos: [],
      curVideo: {},
      videoObj: null,
      progress: [
        {
          title: 'listing数据',
          subtitle: 'listing全生命周期监管，风险异常实时提醒。',
          img: require('@/assets/cross_border_business_9.png'),
          prop: 'listing',
          path: '/sales/listing_list',
          success: 'listing数据拉取完成'
        },
        {
          title: '库存数据',
          subtitle: '多仓数据、在途数据、库存库龄可视化，一屏协同。',
          img: require('@/assets/cross_border_business_8.png'),
          prop: 'inventory',
          path: '/inventory/inventory_fba',
          success: '库存数据拉取完成'
        },
        {
          title: '订单数据',
          subtitle: '销售数据及时准确，销售趋势一目了然。',
          img: require('@/assets/cross_border_business_10.png'),
          prop: 'order',
          path: '/sales/order_list',
          success: '订单数据拉取完成'
        }
      ]
      // tooltipShow: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'localDefaultConfig'
    ]),
    tooltipShow () {
      return Object.values(this.localDefaultConfig.lite).some(i => i >= 100)
    },
    title () {
      return this.userInfo.historicalStatus === 1 ? '使用引导' : '新手引导'
    }
  },
  methods: {
    toAuth (lite) {
      this.$store.dispatch('entry/SetActiveAsync', {
        functionClass: 'SHOPAUTH_PLATFORM_AUTHORIZATION',
        menuParams: {
          lite,
          timestamp: +new Date()
        }
      })
      this.visible = false
    },
    toSeek (path) {
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/amazon#${path}?lite=1&user_account=${this.guideInfo.userAccount}`
      }).then(() => {
         this.visible = false
      })
    },
    // 更改引导展示状态1.未完成且展示3.不再提示()4.未完成保持收起
    changeStatus () {
      const { guideStatus } = this.guideInfo
      switch (guideStatus) {
        case 1:
          this.visible = true
          break
        case 2:
        case 3:
          this.visible = false
          this.flag = false
          break
        case 4:
          this.visible = false
          break
        default:
          break
      }
    },

    hideToolTip () {
      const lite = Object.keys(this.localDefaultConfig.lite).reduce((acc, cur) => {
        const value = this.localDefaultConfig.lite[cur]
        return { ...acc, [cur]: value >= 100 ? -1 : value }
      }, {})
      this.$store.dispatch('SetLocalDefaultConfig', {
        lite
      })
    },

    async init () {
      const options = {
        sy: -40
      }
      const params = {
        paging: false,
        systemName: 'LITE_GUIDE_VIDEO'
      }
      const { dataList } = await QuerySystemParamsPage(params)
      if (dataList?.[0]?.systemValue) {
        this.videos = JSON.parse(dataList[0].systemValue).map(item => ({
          ...item,
          img: ''
        }))
      }
      this.videos.map(item => {
        getVideoBase64(item.templateUrl, options).then(res => {
          item.img = res
        })
      })
      Video.addLanguage('zh-CN', cn)
      this.initVideo()
      this.curVideo = { ...this.videos[0] }
    },

    initVideo () {
      this.$nextTick(() => {
        this.videoObj = Video('#videoLiteBox', {
          playbackRates: [0.5, 1, 1.5, 2],
          width: 580,
          height: 308,
          language: 'zh-CN',
          controls: true,
          muted: true,
          autoplay: true,
          sources: [
            {
              src: this.videos[0].templateUrl
            }
          ]
        }, function () {
          // console.log('视频可以播放了', this)
        })
      })
    },

    changeVideo (video) {
      const { templateUrl } = video
      if (templateUrl === Video.options.src) return
      Video.options.src = templateUrl
      this.videoObj.src(templateUrl)
      this.videoObj.load(templateUrl)
      this.videoObj.play()
      this.curVideo = { ...video }
    },

    test () {
      if (this.guideInfo.guideSchedule[0] === '0') {
        this.guideInfo.guideSchedule[0] = '1'
        this.guideInfo.userAccount = 'thisisuserAccount'
        this.guideInfo.platformUserName = '这是个店铺名称长度很长很长很长很长很长很长很长很长很长'
        this.$forceUpdate()
        return
      }
      const inventory = (this.guideInfo.inventory + 14 >= 100) ? 100 : this.guideInfo.inventory += 14
      const order = (this.guideInfo.order + 10 >= 100) ? 100 : this.guideInfo.inventory += 10
      const listing = (this.guideInfo.listing + 8 >= 100) ? 100 : this.guideInfo.inventory += 8
      const flag = [inventory, order, listing].every(item => item === 100)
      const guideSchedule = this.guideInfo.guideSchedule
      if (flag) {
        guideSchedule[1] = '1'
      }
      if (flag && guideSchedule[2] === '0') {
        guideSchedule[2] = '1'
      } else if (flag && guideSchedule[3] === '0') {
        guideSchedule[3] = '1'
      }
      this.guideInfo = {
        ...this.guideInfo,
        listing,
        order,
        inventory,
        guideSchedule
      }
    },
    setLite (data) {
      if (data.inventory >= 100 || data.listing >= 100 || data.order >= 100) {
        const { inventory, listing, order } = this.localDefaultConfig?.lite || {}
        this.$store.dispatch('SetLocalDefaultConfig', {
          lite: {
            inventory: inventory === -1 ? inventory : data.inventory,
            listing: listing === -1 ? listing : data.listing,
            order: order === -1 ? order : data.order
          }
        })
      }
    },
    /**
     * api
     */
    async queryLiteGuideInfo (userInfo) {
      // 先查询是否有用户需要开启
      if (userInfo && !['development'].includes(process.env.NODE_ENV)) {
        let params = {
          paging: false,
          systemName: 'LITE_LIMIT_USER_IDS'
        }
        let { dataList } = await QuerySystemParamsPage(params)
        let userIds = dataList?.[0]?.systemValue
        if (!userIds) return
        userIds = userIds.split(',')
        if (userIds[0] !== '-1' && !userIds.includes(`${userInfo.userId}`)) return
      }
      // console.log('pass')
      clearTimeout(this.timer)
      if (typeof this.userInfo?.guideStatus === 'number' && [1, 4].includes(this.userInfo?.guideStatus)) {
        this.flag = true
        queryLiteGuideInfo().then(({ data }) => {
          console.log('data?.guideScheduleStr', data?.guideScheduleStr)
          if (!data?.guideScheduleStr) return
          this.guideInfo = {
            ...data,
            guideSchedule: ('' || data.guideScheduleStr).split('')
          }
          this.setLite(data)
          if (userInfo) {
            this.changeStatus()
            this.init()
          }
          if (this.guideInfo.guideSchedule[0] === '1' && this.guideInfo.guideSchedule[1] === '0') {
            this.timer = setTimeout(this.queryLiteGuideInfo, 60 * 1000)
          }
        })
      } else {
        this.flag = false
      }
    },
    updateLiteGuide (guideStatus) {
      if (this.guideInfo.guideSchedule.every(item => item === '1') && this.guideInfo.guideSchedule.length) {
        guideStatus = 2
      }
      updateLiteGuide({
        guideStatus
      })
      this.guideInfo.guideStatus = guideStatus
      this.changeStatus()
    },
    isSellerwell () {
      // 判断是否是启航版
      return IS_SELLERWELL
    }

  },
  watch: {
    visible: {
      handler: function (value, oldValue) {
        this.$nextTick(() => {
          const dom = document.querySelector('.entry-lite-tips')
          const mainWrap = dom.querySelector('.tip-modal .tip-modal__main-wrapper')
          if (!dom) return
          if (value) {
            if (window.innerHeight < 670) {
              // modal.style.zoom = window.innerHeight / 670
              mainWrap.style.height = window.innerHeight * 0.9 - 108 + 'px'
            }
            dom.style.display = 'block'
            dom.style.zIndex = '5000'
            window.requestAnimationFrame(() => {
              dom.classList.add('visible')
              this.videoObj && this.videoObj.play()
            })
          } else {
            dom.classList.remove('visible')
            this.videoObj && this.videoObj.pause()
            setTimeout(() => {
              dom.style.cssText = 'display: none'
            }, 300)
          }
          // 需开闭定时器
          if (typeof oldValue === 'boolean') {
            if (value) {
              this.queryLiteGuideInfo()
            } else {
              clearTimeout(this.timer)
            }
          }
        })
      }
    },
    userInfo: {
      immediate: true,
      handler: 'queryLiteGuideInfo'
    },
    guide: {
      handler: function (val) {
        const data = JSON.parse(val)
        console.log('guide:message:', data)
        this.guideInfo = {
          ...data,
          guideSchedule: data.guideScheduleStr.split('')
        }
        const guideScheduleStr = data.guideScheduleStr.split('')
        const sourceGuideScheduleStr = data.sourceGuideScheduleStr.split('')
        let flag = false
        guideScheduleStr.forEach((item, index) => {
          if (item !== sourceGuideScheduleStr[index] && index !== 1 && item === '1') {
            flag = true
          }
        })
        if (flag) {
          this.visible = true
        }
        this.setLite(data)
        this.$store.commit('user/SET_USER_INFO', {
          ...this.userInfo,
          guideScheduleStr: data.guideScheduleStr
        })
        this.$forceUpdate()
      }
    }
  },
  async mounted () {
    // this.updateLiteGuide(1)
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    this.videoObj && this.videoObj.dispose()
    this.video = null
  }
}
</script>

<style lang="less" scoped>
// 侧边小引导按钮
.entry-lite-mini {
  position: fixed;
  left: 100vw;
  top: 0;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  background: #057afd;
  border-radius: 5px;
  transform: translate(-70px, 80vh);
  z-index: 50;
  padding: 5px 8px;
  user-select: none;
  cursor: pointer;
  width: 140px;
  &__text {
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    display: inline-block;
    vertical-align: top;
  }
  &__star {
    display: flex;
    .anticon {
      font-size: 12px;
      margin-right: 0px;
      color: #cfcfcf;
      background: #cfcfcf;
      border-radius: 50%;
      transform: scale(0.7);
      transform-origin: left top;
      &.pass {
        color: rgba(82, 196, 26, 1);
        background: transparent;
      }
    }
  }
  & > .anticon {
    position: absolute;
    right: 10px;
    top: 8px;
    color: #fff;
    font-size: 14px;
  }
  &__tooltip {
    position: absolute;
    width: 140px;
    right: 0;
    background: #ffffff;
    border-radius: 5px 0 5px 5px;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
    bottom: 43px;
    min-height: 20px;
    & > i {
      position: absolute;
      background: #fff;
      top: -21px;
      right: 0;
      padding: 9px 9px 0 9px;
      border-radius: 5px 5px 0 0;
      box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.08);
      color: rgba(0, 0, 0, 0.25);
      z-index: 2;
      font-size: 12px;
      line-height: 1;
    }
    & > div {
      padding: 0px 4px;
      font-size: 12px;
      list-style: none;
      color: #057afd;
      line-height: 14px;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;
      z-index: 5;
      background: #fff;
      border-radius: 5px 0 5px 5px;
      margin-bottom: 10px;
      .anticon {
        font-size: 14px;
        margin-right: 3px;
      }
      span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:first-child {
        padding-top: 10px;
      }
    }
  }
  &.tooltipShow {
    transition: all 0.3s;
    transform: translate(-140px, 80vh);
  }
}
button {
  box-shadow: none;
  text-shadow: none;
}
// 中间弹窗
.entry-lite-tips {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  &.visible {
    .tip-mask {
      background: rgba(0, 0, 0, 0.27);
    }
    .tip-modal {
      transform: translate(0, -50%);
      opacity: 1;
    }
  }
  .tip-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 1;
    transition: all 0.3s;
  }
  .tip-modal {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -600px;
    transform: translate(0, -50%);
    opacity: 0;
    width: 1200px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    z-index: 2;
    transition: all 0.3s;
    &__title {
      display: flex;
      height: 53px;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      line-height: 1;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px rgba(0, 0, 0, 0.06) solid;
      .anticon {
        color: #8c8c8c;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
    &__main-wrapper {
      overflow-x: hidden;
      overflow-y: auto;
      &::-webkit-scrollbar {
        cursor: pointer;
        width: 8px;
        height: 12px;
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #D9D9D9;
        background-color: #D9D9D9;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        border: 2px #fff solid;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }
    }
    // 弹框主体
    &__main {
      display: flex;
      flex: 1;
      padding: 20px 23px 10px 23px;
      // 视频层
      &--lf {
        width: 580px;
        margin-right: 50px;
        & > b {
          display: block;
          font-size: 16px;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
          margin-top: 6px;
        }
        & > p {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.65);
          line-height: 16px;
          margin: 2px 0 14px;
        }
        .video-main {
          width: 580px;
          height: 308px;
          background: #eee;
          position: relative;
          border-radius: 2px;
          overflow: hidden;
          video {
            width: 580px;
            height: 308px;
          }
        }
        .video-swiper {
          margin: 10px 0 0 0;
          padding: 0;
          .video-item-ob {
            display: inline-block;
            vertical-align: top;
            margin-right: 8px;
            width: 100px;
            position: relative;
            &:hover, &.cur {
              cursor: pointer;
              span {
                color: #057afd;
              }
            }
            &:last-child {
              margin-right: 0;
            }
            div {
              display: block;
              box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.3);
              border-radius: 2px;
              overflow: hidden;
              width: 100px;
              height: 56px;
              background: #eee;
              background-size: cover;
            }
            span {
              display: inline-block;
              vertical-align: top;
              width: 100%;
              font-size: 12px;
              color: rgba(0, 0, 0, 0.65);
              line-height: 16px;
              margin-top: 2px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .playing {
              position: absolute;
              left: 0;
              top: 30px;
              overflow: hidden;
              color: #fff;
              background: rgba(7, 123, 252, 1);
              opacity: 0.75;
              border-radius: 0px 2px 2px 0px;
              padding: 2px 3px;
              font-size: 12px;
              font-style: normal;
            }
          }
        }
      }
      // 步骤层
      &--rt {
        .step {
          background: #ffffff;
          position: relative;
          width: 520px;
          min-height: 127px;
          margin-top: 8px;
          padding: 8px 12px;
          border-radius: 4px;
          box-shadow: 0px 4px 15px 4px rgba(0,0,0,0.03);
          &-top {
            position: relative;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.65);
            b {
              font-size: 14px;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.85);
              line-height: 24px;
            }
            p {
              color: rgba(0, 0, 0, 0.45);
              line-height: 16px;
              margin: 0 0 8px 0;
            }
            &__opt {
              position: absolute;
              right: 12px;
              top: 4px;
              line-height: 14px;
              text-align: right;
              & > div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 300px;
              }
              .anticon {
                font-size: 14px;
                margin-right: 4px;
              }
              button {
                font-size: 12px;
                height: 26px;
                line-height: 24px;
                margin-top: 8px;
              }
              .opt-pull {
                display: inline-block;
                vertical-align: top;
                width: 54px;
                height: 18px;
                background: #e6f1fe;
                border-radius: 2px;
                text-align: center;
                color: #077bfc;
                line-height: 18px;
                margin-bottom: 3px;
              }
            }
          }
          &-continue {
            background: #FAFAFA;
            padding: 10px 9px;
            color: rgba(0, 0, 0, 0.65);
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
              margin: 0;
            }
            .inline-flex {
              line-height: 0;
              display: inline-flex;
              align-items: center;
              height: 18px;
            }
            .anticon {
              font-size: 12px;
              margin-right: 5px;
              color: rgba(82, 196, 26, 1);
              vertical-align: top;
            }
            button {
              margin-left: 10px;
              font-size: 12px;
              padding: 0 8px;
            }
          }
          &.pass {
            &::before,
            &::after {
              background: #077bfc;
            }
          }
          &::before {
            content: "";
            position: absolute;
            display: block;
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: #d8d8d8;
            left: -23px;
            top: 15px;
          }
          &::after {
            content: "";
            position: absolute;
            display: block;
            top: 15px;
            bottom: -31px;
            width: 1px;
            left: -10-7px;
            background: #d8d8d8;
          }
          &:first-child {
            margin-top: 0;
          }
          &:last-child {
            &::after {
              bottom: 100%;
            }
          }
        }
        .step-success {
          display: flex;
          justify-content: center;
          text-align: center;
          flex-wrap: wrap;
          padding-right: 30px;
          b {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            padding: 100px 0 36px;
            display: block;
            width: 100%;
          }
          ul {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0;
            margin: 28px 40px 0 40px;
            li {
              list-style: none;
              display: inline-flex;
              align-items: center;
              line-height: 1;
              .anticon {
                font-size: 16px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
    &__footer {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 54px;
      padding: 0 24px;
      border-top: 1px rgba(0, 0, 0, 0.06) solid;
      background: #fff;
      [class$=background-ghost] {
        border: 1px solid #d9d9d9;
        color: rgba(0, 0, 0, 0.65);
        &:hover {
          color: #077bfc;
          border-color: #077bfc;
        }
      }
      button {
        box-shadow: none;
        margin-left: 8px;
        font-size: 12px;

      }
    }
  }
}

.progress-item {
  padding: 8px;
  display: flex;
  align-items: center;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  margin-bottom: 6px;
  font-size: 12px;
  &__pct {
    flex: 0 0 32px;
    width: 40-8px;
    color: rgba(0, 0, 0, 0.45);
  }
  &__pie {
    width: 50px;
    height: 50px;
    .circular-chart {
      height: 50px;
      overflow: visible !important;
      // background: rgba(0, 0, 0, 0.05);
      .circle-bg {
        fill: none;
        stroke: #e8e8e8;
        stroke-width: 6;
      }
      .circle {
        fill: none;
        stroke-width: 6;
        transition: all 0.3s;
        stroke-linecap: round;
        // animation: progress 5s infinite;
        stroke: #077bfc;
      }
    }
  }
  &__content {
    font-size: 12px;
    margin-left: 13px;
    flex: 1;
    span {
      color: rgba(0, 0, 0, 0.85);
      line-height: 16px;
      display: block;
      margin-bottom: 4px;
    }
    p {
      color: rgba(0, 0, 0, 0.45);
      line-height: 16px;
      margin: 0;
    }
  }
  &__pass {
    display: inline-flex;
    justify-self: flex-end;
    justify-content: flex-end;
    text-align: right;
    flex-wrap: wrap;
    flex: 0 0 70px;
    button {
      font-size: 12px;
      padding: 0;
      height: 18px;
      line-height: 18px;
    }
  }
}
</style>
